import { getHeaders, makeRequest } from "$utils/utils";
import constants from "$utils/constants";

export enum ERRORS {
  EXISTS = "Ce produit existe déjà",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout d'un produit",
  UPDATE_ERROR = "Une erreur s'est produite lors de l'édition du coordinateur",
  MISSING_FIELD = "Donnée manquante !",
}

export const addProduct = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      constants.API.ENDPOINTS.PRODUCT.ADD,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when adding user");
    }
    return res;
  } catch (err: any) {
    let error = err?.response?.data?.message || "";
    if (error && error.includes("exist")) {
      error = ERRORS.EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const editProduct = async (token: string, data: any, id?: string) => {
  try {
    const res = await makeRequest(
      `${constants.API.ENDPOINTS.PRODUCT.IMPORT}/${id || ""}`,
      "PUT",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when editing data");
    }
    return res;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("exists")) {
      error = ERRORS.EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const deleteProduct = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${constants.API.ENDPOINTS.PRODUCT.IMPORT}/${id}`,
      "DELETE",
      {},
      getHeaders(token)
    );
    if (!res) {
      throw new Error("Error when trying to delete product");
    }
    return res;
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { status: 403, message: error };
  }
};

export const getProduct = async (
  token: string,
  company = "",
  force = false
) => {
  try {
    const params = company?.trim().length > 0 ? { company } : undefined;
    let url = `${constants.API.ENDPOINTS.PRODUCT.ADD}?company=${company}`;
    if (force) {
      url = `${constants.API.ENDPOINTS.PRODUCT.ADD}?force=true`;
    }
    const response = await makeRequest(url, "GET", params, getHeaders(token));

    return response;
  } catch (err: any) {
    return err;
  }
};

export const deleteReceptionReferences = async (
  token: string,
  companyId: string,
  receptionId: string,
  receptionReferences: any
) => {
  try {
    const res = await makeRequest(
      `${constants.API.ENDPOINTS.PRODUCT.RECEPTION}/${receptionId}`,
      "DELETE",
      { companyId, receptionReferences },
      getHeaders(token)
    );
    if (!res) {
      throw new Error("Error when trying to delete product");
    }
    return res;
  } catch (err: any) {
    const error = (err as any)?.response?.data?.message;
    return { status: 403, message: error };
  }
};

export default { addProduct, getProduct, deleteProduct };
